import React, { useState } from 'react';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { Collapse, Hidden, IconButton } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { useTheme } from '../../context/theme/theme';
import { CustomText, CustomLink, CustomH4 } from './FooterComponent';
import SupportSite from './SupportSite';
import { Container } from '../common';
import { useLanguage } from '../../context/language/language';
import { contactEmail, contactPhone, linkDownload } from '../../utils/constant';
import urlResolver from '../../constant/urlPattern';
import { getImageURL } from '../../utils/getImageURL';
import { trackClickFooterSmartXLogo, trackClickFooterMenu } from '../../utils/eventTracking';

const smartxLogo = getImageURL('/logo/smartx-logo-footer.svg');
const qrCodeApp = getImageURL('/images/qrcode-app.png');

const useStyles = makeStyles((theme,) => ({
  textCenter: {
    textAlign: 'center',
  },
  mb20: {
    marginBottom: 20,
  },
  pb20: {
    paddingBottom: 20,
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
  },
  pb10: {
    paddingBottom: 10,
  },
  sitemapContainer: {
    display: 'flex',
    justifyContent: 'center',
    wordWrap: 'nowrap',
  },
  logoIcon: (props) => ({
    width: 95,
    height: 20,

    [theme.breakpoints.up('md')]: {
      width: props.columnAmount <= 3 ? 139 : 95,
      height: props.columnAmount <= 3 ? 29 : 20,
    },
    [theme.breakpoints.up('lg')]: {
      width: 139,
      height: 29,
    },
  })
}));

const FooterLinkContainer = styled.div(({ theme }) => ({
  ...theme.fonts.textS,
  backgroundColor: theme.colors.grey25,
}));

const TelLink = styled.a(({ theme }) => ({
  ...theme.fonts.header3,
  color: theme.colors.grey700,
}));

const ContactAndDownloadApp = ({ theme, isMobile = false }) => {
  const word = useLanguage();

  return (
    <>
      <Grid
        item
        xs={isMobile ? 12 : 6}
        md={isMobile ? 12 : 2}
        style={{ paddingRight: 0 }}
      >
        <CustomText theme={theme}>
          {word('Header.DownloadApplication')}
        </CustomText>
        <div>
          <div style={theme.isTablet ? { display: 'block' } : { display: 'flex', flexDirection: 'row' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginRight: 10,
              }}
            >
              <img
                style={{
                  width: '66px',
                  height: '66px',
                }}
                src={qrCodeApp}
                alt="QrCode"
              />
            </div>
            <ul className="hle-footer-item-list" style={theme.isTablet ? { marginTop: 10 } : {}}>
              <li>
                <CustomLink
                  id="footer-apple-store"
                  data-cta-name-en="Footer"
                  data-cta-name-th="ส่วนท้าย"
                  data-cta-type="Link"
                  theme={theme}
                  href={linkDownload}
                  target="_blank"
                  onClick={() => trackClickFooterMenu('download_application', word('Footer.AppleStore'))}
                >
                  {word('Footer.AppleStore')}
                </CustomLink>
              </li>
              <li>
                <CustomLink
                  id="footer-google-play"
                  data-cta-name-en="Footer"
                  data-cta-name-th="ส่วนท้าย"
                  data-cta-type="Link"
                  theme={theme}
                  href={linkDownload}
                  target="_blank"
                  onClick={() => trackClickFooterMenu('download_application', word('Footer.GooglePlay'))}
                >
                  {word('Footer.GooglePlay')}
                </CustomLink>
              </li>
              <li>
                <CustomLink
                  id="footer-galary"
                  data-cta-name-en="Footer"
                  data-cta-name-th="ส่วนท้าย"
                  data-cta-type="Link"
                  theme={theme}
                  href={linkDownload}
                  target="_blank"
                  onClick={() => trackClickFooterMenu('download_application', word('Footer.AppGallery'))}
                >
                  {word('Footer.AppGallery')}
                </CustomLink>
              </li>
            </ul>
          </div>
        </div>
      </Grid>
    </>
  );
};
const FooterItemCols = ({ data, theme }) => (
  <>
    {data
        && data.map(({ columnTitle, columnItems }, listIndex) => (
          <Grid
            item
            xs={6}
            md={2}
            id={`divItemList${listIndex + 1}`}
            key={`colItemList${listIndex + 1}`}
          >
            <CustomText
              theme={theme}
              id={`pItemListHeader${listIndex + 1}`}
            >
              {columnTitle}
            </CustomText>
            <FooterItemListLink
              links={columnItems}
              listIndex={listIndex}
              theme={theme}
            />
          </Grid>
        ))}
    <ContactAndDownloadApp theme={theme} />
  </>
);

const FooterItemColsMobile = ({ data, theme }) => {
  const word = useLanguage();

  const initDataExpanded = data
    && data.map((x, index) => ({
      index,
      expanded: false,
    }));

  const [expanded, setExpanded] = useState(initDataExpanded);

  const getExpandedByIndex = (index) => {
    const result = expanded.find((exp) => exp.index === index);
    return result.expanded;
  };

  const setExpandedByIndex = (index, result) => {
    const data = expanded.map((exp) => {
      if (exp.index === index) {
        return {
          index: exp.index,
          expanded: result,
        };
      }
      return exp;
    });
    setExpanded(data);
  };

  return (
    <>
      {data
        && data.map(({ columnTitle, columnItems }, listIndex) => (
          <Grid
            key={`footerItem${listIndex}`}
            item
            xs={12}
            style={{ paddingTop: 0, paddingBottom: 0 }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <CustomText theme={theme}>{columnTitle}</CustomText>
              <IconButton
                style={{ color: theme.colors.grey700 }}
                onClick={() =>
                  setExpandedByIndex(listIndex, !getExpandedByIndex(listIndex))}
                aria-expanded={expanded}
                aria-label="show more"
              >
                {getExpandedByIndex(listIndex) ? (
                  <ExpandLessIcon />
                ) : (
                  <ExpandMoreIcon />
                )}
              </IconButton>
            </div>
            <Collapse
              in={getExpandedByIndex(listIndex)}
              timeout="auto"
              unmountOnExit
            >
              <FooterItemListLink
                links={columnItems}
                listIndex={listIndex}
                theme={theme}
              />
            </Collapse>
          </Grid>
        ))}
      <Grid item xs={12} md={2}>
        <CustomText theme={theme}>
          {word('Footer.ContactUs')}
        </CustomText>
        <ul className="hle-footer-item-list">
          <li>
            <CustomLink
              id="footer-mail"
              data-cta-name-en="Footer"
              data-cta-name-th="ส่วนท้าย"
              data-cta-type="Link"
              theme={theme}
              href={`mailto:${contactEmail}`}
            >
              {contactEmail}
            </CustomLink>
          </li>
          <li>
            <TelLink
              id="footer-tel"
              data-cta-name-en="Footer"
              data-cta-name-th="ส่วนท้าย"
              data-cta-type="Link"
              href={`tel:${contactPhone}`}
            >
              {contactPhone}
            </TelLink>
          </li>
        </ul>
      </Grid>
      <ContactAndDownloadApp isMobile theme={theme} />
    </>
  );
};

const FooterItemListLink = ({ links, listIndex, theme }) => (
  <ul className="hle-footer-item-list" id={`ulItemList${listIndex + 1}`}>
    {links
      && links.map(({ topic, url, openInNewTab }, itemIndex) => (
        <li key={`liItem${listIndex + 1}_${itemIndex + 1}`}>
          <CustomH4
            theme={theme}
            onClick={() => {
              trackClickFooterMenu('about', topic);
              if (openInNewTab) {
                window.open(url, '_blank').focus();
              } else {
                window.location.href = url;
              }
            }}
            id={`aItem${listIndex + 1}_${itemIndex + 1}`}
          >
            {topic}
          </CustomH4>
        </li>
      ))}
  </ul>
);

const FooterLink = ({ footerlinks }) => {
  const theme = useTheme();
  const classes = useStyles({ columnAmount: footerlinks?.length });
  const href = urlResolver('home');
  return (
    <FooterLinkContainer theme={theme}>
      <Container>
        <Grid
          container
          justify="space-between"
          spacing={4}
          className={classes.pb20}
        >
          <Grid
            item
            xs={12}
            md={2}
            className={classes.logo}
            style={{ paddingRight: 2 }}
          >
            <CustomLink
              id="footer-home"
              data-cta-name-en="Footer"
              data-cta-name-th="ส่วนท้าย"
              data-cta-type="Link"
              theme={theme}
              href={href}
              onClick={trackClickFooterSmartXLogo}
            >
              <img className={classes.logoIcon} src={smartxLogo} alt="Lotus" />
            </CustomLink>
          </Grid>
          <Hidden xsDown>
            <>
              <FooterItemCols theme={theme} data={footerlinks} />
            </>
          </Hidden>
          <Hidden smUp>
            <>
              <FooterItemColsMobile theme={theme} data={footerlinks} />
            </>
          </Hidden>
        </Grid>
        <SupportSite />
      </Container>
    </FooterLinkContainer>
  );
};

export default FooterLink;
